import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TCapacityDB } from './capacity.reducer';

export const CAPACITY_APP_STATE = 'CAPACITY_APP_STATE';
export const capacityDB = createFeatureSelector<TCapacityDB>(CAPACITY_APP_STATE);

export const getCapacityList = createSelector(capacityDB, (db) => {
  return db.capacityList;
});

export const getCapacityActivityLog = createSelector(capacityDB, (db) => {
  return db.activityLog;
});

export const getCapacityDropdownData = createSelector(capacityDB, (db) => {
  return db.capacityDropdown;
});
